import React from 'react';
import { Drawer, IconButton, Paper, useMediaQuery } from '@mui/material';
import { ChevronLeft as ChevronLeftIcon, Clear as ClearIcon } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
function RightDrawer({ children, width }) {
    const theme = useTheme();
    const isBigScreen = useMediaQuery(theme.breakpoints.up('sm'));
    const [drawerOpen, setDrawerOpen] = React.useState(isBigScreen);
    return (React.createElement(React.Fragment, null,
        React.createElement(Paper, { variant: "outlined", sx: { position: 'absolute', top: 52, right: 5, zIndex: theme.zIndex.drawer + 1 } },
            React.createElement(IconButton, { onClick: () => setDrawerOpen((e) => !e) }, drawerOpen ? React.createElement(ClearIcon, { fontSize: "small", color: "action" }) : React.createElement(ChevronLeftIcon, { fontSize: "small" }))),
        React.createElement(Drawer, { open: drawerOpen, anchor: "right", variant: "persistent", hideBackdrop: true, PaperProps: {
                sx: {
                    right: 5,
                    top: '86px',
                    height: 'auto',
                    zIndex: theme.zIndex.drawer,
                    maxHeight: 'calc(100% - 118px)',
                    // Clamp on narrow screens so the drawer never exceeds the
                    // viewport on a phone.
                    width: `min(${typeof width === 'number' ? width + 'px' : width || '360px'}, calc(100vw - 16px))`,
                    border: 'none',
                    backgroundColor: 'transparent',
                },
            } }, children)));
}
export default React.memo(RightDrawer);
